// extracted by mini-css-extract-plugin
module.exports =  {"icon":"_2787e5dfdf--icon--fZfr_","expand":"_2787e5dfdf--expand--ouvlO"};